import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import PageLoader from 'components/common/PageLoader';
import capitalize from 'utils/capitalize';
import formatNumber from 'helpers/formatNumber';
import Empty from 'components/common/Empty';
import Thumbnail from 'components/common/Thumbnail';
import './index.scss';

const GroupWalletTable = ({ groups, loading, error }) => {
  if (loading) return <PageLoader />;

  if (!loading && error) return null;

  if (!loading && !error && groups.length === 0) {
    return <Empty message="No groups found" />;
  }

  return (
    <div className="group-wallet-table">
      <Table basic="very" size="large">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell className="group-wallet-table__header group-wallet-table__header--name">
              Saving Group
            </Table.HeaderCell>
            <Table.HeaderCell className="group-wallet-table__header">
              Members
            </Table.HeaderCell>
            <Table.HeaderCell className="group-wallet-table__header">
              Wallet Balance
            </Table.HeaderCell>
            <Table.HeaderCell className="group-wallet-table__header">
              Total Savings
            </Table.HeaderCell>
            <Table.HeaderCell className="group-wallet-table__header">
              Social Fund
            </Table.HeaderCell>
            <Table.HeaderCell className="group-wallet-table__header">
              Status
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {groups.map(group => (
            <Table.Row
              key={group.id}
              className="group-wallet-table__row"
            >
              <Table.Cell className="group-wallet-table__cell--name">
                <Link
                  to={`/wallets/group/${group.id}`}
                  className="group-wallet-table__name-link"
                >
                  <Thumbnail name={group.name} />
                  <span className="group-wallet-table__name-text">
                    {capitalize(group.name)}
                  </span>
                </Link>
              </Table.Cell>
              <Table.Cell className="group-wallet-table__cell--number">
                {formatNumber(group.members_count || 0)}
              </Table.Cell>
              <Table.Cell className="group-wallet-table__cell--number">
                {formatNumber(group.wallet_balance || 0)}
              </Table.Cell>
              <Table.Cell className="group-wallet-table__cell--number">
                {formatNumber(group.savings_total || 0)}
              </Table.Cell>
              <Table.Cell className="group-wallet-table__cell--number">
                {formatNumber(group.social_funds_total || 0)}
              </Table.Cell>
              <Table.Cell className="group-wallet-table__cell--status">
                <span
                  className={`group-wallet-table__status group-wallet-table__status--${group.status}`}
                >
                  {group.status?.toUpperCase()}
                </span>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </div>
  );
};

GroupWalletTable.propTypes = {
  groups: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
};

GroupWalletTable.defaultProps = {
  error: null,
};

export default GroupWalletTable;
